import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';

import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { getCronofyAccessToken, revokeCronofyAccessToken } from '../../util/api';
import { parse } from '../../util/urlHelpers';
import { createImageVariantConfig } from '../../util/sdkLoader';

// ================ Action types ================ //

export const SYNC_CALENDER_REQUEST = 'app/CronofyPage/SYNC_CALENDER_REQUEST';
export const SYNC_CALENDER_SUCCESS = 'app/CronofyPage/SYNC_CALENDER_SUCCESS';
export const SYNC_CALENDER_ERROR = 'app/CronofyPage/SYNC_CALENDER_ERROR';

export const FETCH_LSITING_BY_ID_REQUEST = 'app/CronofyPage/FETCH_LSITING_BY_ID_REQUEST';
export const FETCH_LISTING_BY_ID_SUCCESS = 'app/CronofyPage/FETCH_LISTING_BY_ID_SUCCESS';
export const FETCH_LSITING_BY_ID_ERROR = 'app/CronofyPage/FETCH_LSITING_BY_ID_ERROR';

// ================ Reducer ================ //

const initialState = {
    syncData: {},
    syncDataInProgress: false,
    syncDataError: null,
    listing: null,
    fetchListing: false,
    listingFetchError: null
};

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case SYNC_CALENDER_REQUEST:
            return {
                ...state,
                syncDataInProgress: true,
                syncDataError: null,
            };
        case SYNC_CALENDER_SUCCESS:
            return {
                ...state,
                syncData: payload,
                syncDataInProgress: false,
            };
        case SYNC_CALENDER_ERROR:
            return {
                ...state,
                syncDataInProgress: false,
                syncDataError: payload,
            };
        case FETCH_LSITING_BY_ID_REQUEST:
            return { ...state, fetchListing: true, listing: null, listingFetchError: null };
        case FETCH_LISTING_BY_ID_SUCCESS:
            return { ...state, fetchListing: false, listing: payload, listingFetchError: null };
        case FETCH_LSITING_BY_ID_ERROR:
            return { ...state, fetchListing: false, listing: null, listingFetchError: payload };
        default:
            return state;
    }
}

// ================ Action creators ================ //

export const updateSyncRequest = () => ({
    type: SYNC_CALENDER_REQUEST
});
export const updateSyncSuccess = (response) => {
    return {
        type: SYNC_CALENDER_SUCCESS,
        payload: response,
    };
};
export const updateSyncError = error => ({
    type: SYNC_CALENDER_ERROR,
    payload: error,
    error: true,
});

export const fetchListingRequest = () => ({
    type: FETCH_LSITING_BY_ID_REQUEST,
});
export const fetchListingSuccess = (resp) => ({
    type: FETCH_LISTING_BY_ID_SUCCESS,
    payload: resp
});
export const fetchListingError = (error) => ({
    type: FETCH_LSITING_BY_ID_ERROR,
    payload: error
});

// ================ Thunks ================ //

export const chronofyCalenderSync = (params) => (dispatch, getState, sdk) => {
    dispatch(updateSyncRequest(params));

    return getCronofyAccessToken(params)
        .then(response => {
            if (response && response?.data) {
                dispatch(updateProfile({
                    protectedData: {
                        cronofySyncData: response.data
                    }
                }));
            }
            return dispatch(updateSyncSuccess(response.data));
        })
        .catch(e => {
            console.error(e, '&&& &&& => e');
            return dispatch(updateSyncError(storableError(e)));
        });
};

export const chronofyCalenderRevoke = (params) => (dispatch, getState, sdk) => {
    dispatch(updateSyncRequest(params));

    return revokeCronofyAccessToken(params)
        .then(response => {
            if (response && response?.message) {
                dispatch(updateProfile({
                    protectedData: {
                        cronofySyncData: {}
                    },
                    publicData: {
                        instant_booking: false,
                    }
                }));
            }
            return dispatch(updateSyncSuccess(response.data));
        })
        .catch(e => {
            dispatch(updateSyncError(storableError(e)));
            console.log(e, '&&& &&& => e');

        });
};

export const fetchListingById = ({ listingId, config }) => async (dispatch, getState, sdk) => {
    dispatch(fetchListingRequest());
    const {
        aspectWidth = 1,
        aspectHeight = 1,
        variantPrefix = 'listing-card',
    } = config?.layout?.listingImage || {};

    const aspectRatio = aspectHeight / aspectWidth;

    const params = {
        id: listingId,
        include: ['author', 'author.profileImage', 'images', 'currentStock'],
        'fields.image': [
            // Scaled variants for large images
            'variants.scaled-small',
            'variants.scaled-medium',
            'variants.scaled-large',
            'variants.scaled-xlarge',

            // Cropped variants for listing thumbnail images
            `variants.${variantPrefix}`,
            `variants.${variantPrefix}-2x`,
            `variants.${variantPrefix}-4x`,
            `variants.${variantPrefix}-6x`,

            // Social media
            'variants.facebook',
            'variants.twitter',

            // Avatars
            'variants.square-small',
            'variants.square-small2x',
        ],
        ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
        ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
        ...createImageVariantConfig(`${variantPrefix}-4x`, 1600, aspectRatio),
        ...createImageVariantConfig(`${variantPrefix}-6x`, 2400, aspectRatio),
    };

    const show = sdk.listings.show(params);

    return show
        .then(resp => {
            const listing = resp.data.data;
            dispatch(fetchListingSuccess(listing));
            return listing;
        })
        .catch(e => {
            dispatch(showListingError(storableError(e)));
            dispatch(fetchListingError(e));
        });
};

export const loadData = (params, search) => async (dispatch, getState, sdk) => {
    const { code } = parse(search);

    await dispatch(fetchCurrentUser());
    const state = getState();
    const { currentUser } = state.user || {};

    const { listingInfo = {} } = (currentUser && currentUser.id && currentUser.attributes.profile.publicData) || {};
    const { listingId } = listingInfo;

    if (listingId) {
        await dispatch(fetchListingById({ listingId }));
    }

    if (code) {
        return dispatch(chronofyCalenderSync({ code }));
    }
    return Promise.all([]);
};